import { drawThumbnail, thumbnailLayout, type ThumbnailInfo, type ThumbnailPicture } from './climb-thumbnail';
import { drawWatermark } from './watermark';

/** The width "share image" exports at: a phone's full-width story. */
export const SHARE_CARD_WIDTH = 1080;

/**
 * The picture "share image" sends: the climb's card on its own, with the mark
 * in its bottom-right corner — over the band, whose stars are on the left.
 * Draws onto `canvas`, sizing it.
 */
export function drawShareCard(
  canvas: HTMLCanvasElement,
  picture: ThumbnailPicture,
  info: ThumbnailInfo,
  logo: CanvasImageSource | null,
  width: number = SHARE_CARD_WIDTH,
) {
  const layout = thumbnailLayout(picture, info, width);
  const height = Math.round(layout.height);
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  ctx.clearRect(0, 0, width, height);
  drawThumbnail(ctx, 0, 0, layout, picture, info);
  drawWatermark(ctx, width, height, logo);
}

/** The card as a file to share: a JPEG, since it is a photograph with nothing see-through in it. */
export function shareCardFile(canvas: HTMLCanvasElement, name: string): Promise<File | null> {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => resolve(blob ? new File([blob], `${name}.jpg`, { type: 'image/jpeg' }) : null),
      'image/jpeg',
      0.92,
    );
  });
}
